export enum LoginApiModelResult {
  Unknown = `Unknown`,
  Error = `Error`,
  Success = `Success`,
  InterceptorRequired = 'InterceptorRequired',
  SetPasswordRequired = 'SetPasswordRequired'
}
